import styled from "styled-components";
import { ReactComponent as BackButton } from "assets/icons/icon-back-24.svg";
import { PreviousIcon } from "common/components/icon";
import { useNavigate } from "react-router";
import {
  TextHeading3,
  TextTitle3,
} from "common/components/Style/new/textStyle";
import { colors } from "common/const/colors";
import { SideBarBackground } from "common/components";

const LayoutWrapper = styled.div`
  display: flex;
  flex: 1;
  width: calc(100% - 3rem);

  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: var(--White);
  border-radius: var(--border-radius-16);
  padding: ${({ $innerWidth }) =>
    $innerWidth ? `6rem calc(100% - ${$innerWidth})` : "3.5rem 3rem"};
  margin: 1.5rem;
  gap: ${({ gap }) => gap ?? "3rem"};
  box-sizing: border-box;
`;

const DefaultLayout = ({
  title,
  subtitle,
  showBackButton = false,
  showLogo = false,
  innerWidth,
  gap,
  children,
  idName,
  titleRightElement,
}) => {
  const navigate = useNavigate();

  return (
    <LayoutWrapper $innerWidth={innerWidth} id={idName} gap={gap}>
      <SideBarBackground />
      <ContentHeader>
        {showBackButton && (
          <PreviousIcon
            onClick={() => navigate(-1)}
            style={{ marginRight: "1rem" }}
          />
        )}
        {title && (
          <TextHeading3 style={{ marginRight: "0.5rem" }}>{title}</TextHeading3>
        )}
        {subtitle && (
          <TextTitle3 color={colors.LightNavy}>{subtitle}</TextTitle3>
        )}

        {titleRightElement && titleRightElement}
      </ContentHeader>
      {children}
    </LayoutWrapper>
  );
};

const ContentHeader = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  align-items: flex-end;
  justify-content: flex-start;
`;

const WithOutSideBarLayoutContainer = styled.div`
  position: relative;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 100vh;
  width: 100vw;

  overflow-y: auto;
`;

const WithOutSideBarLayout = ({
  isBackButton = true,
  isScroll = false,
  needBackground = false,
  children,
}) => {
  return (
    <WithOutSideBarLayoutContainer
      style={{
        height: isScroll ? "auto" : "100vh",
        justifyContent: isScroll ? "flex-start" : "center",
        backgroundImage: needBackground
          ? `url(${require("assets/images/worldmap.png")})`
          : "none",
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        backgroundPosition: "center",
      }}>
      {isBackButton && (
        <BackButton
          style={{
            position: "fixed",
            top: "2rem",
            left: "2rem",
            cursor: "pointer",
            zIndex: 100,
          }}
          onClick={() => {
            if (window.location.pathname === "/") {
              window.location.href = "/";
            } else window.history.back();
          }}
        />
      )}
      {children}
    </WithOutSideBarLayoutContainer>
  );
};

const Row = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: auto;
  justify-content: auto;
  gap: ${(props) => props.gap ?? "1rem"};
  box-sizing: border-box;
`;

const Column = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: auto;
  justify-content: auto;
  gap: ${(props) => props.gap ?? "1rem"};
  box-sizing: border-box;
`;

const RowLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  gap: 1rem;
`;

const RowEndLayout = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: flex-end;
  width: 100%;
  gap: 1rem;
`;

const ColumnLayout = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  gap: ${({ gap }) => gap || "1rem"};
`;

export {
  DefaultLayout,
  WithOutSideBarLayout,
  RowLayout,
  RowEndLayout,
  ColumnLayout,
  Row,
  Column,
};
